import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-system-error-msg',
  templateUrl: './system-error-msg.component.html',
  styleUrls: ['./system-error-msg.component.scss']
})
export class SystemErrorMsgComponent implements OnInit {
  @Output() goToBeginning = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  goToHome() {
    this.goToBeginning.emit();
  }

}
